var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTransportation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.8867C12.8837 18.8867 13.6006 19.5832 13.6006 20.4424C13.6006 21.3015 12.8836 21.998 12 21.998C11.1165 21.9978 10.4004 21.3014 10.4004 20.4424C10.4004 20.4097 10.4013 20.3769 10.4033 20.3447C10.4551 19.5312 11.1502 18.8869 12 18.8867ZM20.8008 18.8867C21.6843 18.8869 22.4004 19.5834 22.4004 20.4424C22.4004 21.3014 21.6842 21.9978 20.8008 21.998C19.9171 21.998 19.2002 21.3015 19.2002 20.4424C19.2002 19.5832 19.9171 18.8867 20.8008 18.8867ZM14 8C15.7673 8 17.2002 9.39304 17.2002 11.1113V20.4453H14.7998C14.7998 18.9418 13.5464 17.7227 12 17.7227C10.6751 17.7227 9.56555 18.6172 9.27441 19.8193C8.50034 19.2515 8.00009 18.3494 8 17.334V11.1113C8 9.39304 9.43288 8 11.2002 8H14ZM20.168 11.1094C20.5743 11.1094 20.9652 11.2601 21.2617 11.5303L23.4951 13.5654C23.8176 13.8595 24 14.2704 24 14.7002V18.8877C23.9999 19.3046 23.8313 19.6836 23.5566 19.9629C23.3232 18.6887 22.1783 17.7209 20.8008 17.7207C19.7823 17.7207 18.8904 18.2495 18.4004 19.04V11.1094H20.168Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTransportation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/transportation.406659ad2d3fbf99307f2804b4906915.svg";